// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
require('./common/js/global-config');
require('./common/js/common-filter');
import echarts from 'echarts'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
import '../static/iconfont/iconfont.css'
import './assets/common.scss'

import '@/directives/directives.js';
import commonPlugin from './plugins/common.js'
import './common/lib/flexible.js'
import NoData from './components/common/NoData'
import VueClipboard from 'vue-clipboard2'
Vue.prototype.$echarts = echarts
// import VConsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole)

Vue.use(VueClipboard)
Vue.use(ElementUI)
Vue.use(commonPlugin)

Vue.config.productionTip = false


Vue.component('NoData', NoData)
/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: {
		App
	},
	template: '<App/>',
	beforeMount() {
		this.$reCharts.windowResizeECharts()
	}
})



// WEBPACK FOOTER //
// ./src/main.js